import React from 'react'
import styles from './DataRow.less'
import { IconButton } from './IconButton'
import _ from 'common-tools/LodashHelper'
import { sh, ah, compose, ReduxWrapper } from 'common-data/datahelpers'
import { FloatGroup } from './FloatGroup'

export { DataRowStatusLine } from './DataRowCustom/DataRowStatusLine'
export { DataRowFieldsLine } from './DataRowCustom/DataRowFieldsLine'
export { DataRowLabelLine } from './DataRowLabelLine'

export class DataRowPlain extends React.Component {
  static defaultProps = {
    actions: [],
    alerts: [],
    showGray: false,
    showPicture: false,
    emptyPictureIcon: 'user',
    allowTopAction: false
  }

  renderActions () {
    const { actions, SessionAccount, allowTopAction } = this.props
    if (_.isArray(actions) === false) {
      return null
    }

    const actionButtons = _.map(actions, (a, i) => {
      // if (!TestIdList(SessionUser.Modules, a.modules || [])) {
      //   return null
      // }

      // if (!TestIdList(SessionUser.Permissions, a.permissions || [])) {
      //   return null
      // }

      return (
        <IconButton size='sm'
          className={styles.actionButton} key={i}
          helpTextPlacement='bottom'
          onClick={(e) => { if (_.isFunction(a.onClick)) { a.onClick(); e.stopPropagation(); e.nativeEvent.stopImmediatePropagation() } else { e.stopPropagation() } }}
          name={a.icon}
          helpText={a.helpText}
          type={a.type}
          secondary={a.secondary} />
      )
    })

    let ret = null
    if ((actionButtons || []).length > 0) {
      if (actionButtons.length === 1 & allowTopAction) {
        ret = actionButtons[0]
        console.log('actionButtons only 1', actionButtons[0])
      } else {
        console.log('actionButtons', actionButtons)
        ret = (<FloatGroup margin={40} direction='left' style={{ margin: '0 10px' }}>
          <IconButton size='sm' className={styles.floatButton} type='Info' name='ellipsis-h' />
          {actionButtons}
        </FloatGroup>

        )
      }
    }

    return (<div className={styles.innerCardActionContainer}>
      {ret}
    </div>)
  }

  renderSummary () {
    const { showPicture, pictureKey, emptyPictureIcon, fields, SessionToken } = this.props

    var primaryInfo1 = _.find(fields, { type: 'Primary1' })
    var primaryInfo2 = _.find(fields, { type: 'Primary2' })
    var primaryInfo3 = _.find(fields, { type: 'Primary3' })
    var primaryInfo4 = _.filter(fields, { type: 'Primary4' })
    var primaryInfo5 = _.filter(fields, { type: 'Primary5' })

    if (showPicture === false & !primaryInfo1 & !primaryInfo2 & !primaryInfo3) {
      if (!primaryInfo4 & !primaryInfo5) { return null }
    }

    var pictureURL = null

    // if (_.startsWith(picture, '/') & _.startsWith(SessionAccount.url, 'http://localhost')) {
    pictureURL = `/Files/Get/${pictureKey}/?token=${SessionToken}`// `http://localhost:60000${picture}`
    // } else {
    //  pictureURL = picture
    // }

    return (
      <div className={styles.cardFlexRow}>
        {showPicture
          ? <div className={styles.cardsProfileImgs}>
            {pictureURL ? <img src={pictureURL} /> : <div name={emptyPictureIcon} />}
          </div>
          : null
        }
        <div className={styles.cardInfoWrapper} >
          {primaryInfo1
            ? <div className={styles.cardInfoPrimary1}>{primaryInfo1.value}</div>
            : null
          }
          {primaryInfo2
            ? <div className={styles.cardInfoPrimary2}>{primaryInfo2.value}</div>
            : null
          }
          {primaryInfo3
            ? <div className={styles.cardInfoPrimary3}>{primaryInfo3.value}</div>
            : null
          }
          {(primaryInfo4 ? primaryInfo4.length > 0 : false)
            ? <div className={styles.cardInfoPrimary4}>
              {_.map(primaryInfo4, (info, i) => {
                if (_.isNil(info.value)) {
                  return
                }
                if (i > 0) {
                  return [
                    <div key={`line_${i}`} className={styles.lineDivider}></div>,
                    <div key={`value_${i}`} className={styles.cardInfoPrimary4Text}>{info.value}</div>
                  ]
                } else {
                  return <div key={`line_${i}`} className={styles.cardInfoPrimary4Text}>{info.value}</div>
                }
              })}
            </div>
            : null
          }
          { (primaryInfo4 ? primaryInfo5.length > 0 : false)
            ? <div className={styles.cardInfoPrimary5}>
              {_.map(primaryInfo5, (info, i) => {
                if (_.isNil(info.value)) {
                  return
                }
                if (i > 0) {
                  return [
                    <div key='line' className={styles.lineBreak}></div>,
                    <div key='value' className={styles.cardInfoPrimary5Text}>{info.value}</div>
                  ]
                } else {
                  return <div className={styles.cardInfoPrimary5Text}>{info.value}</div>
                }
              })}
            </div>
            : null
          }
        </div>
        {/* <div className={styles.boxAlerts}>
            {_.map(alerts, (a, i) => {
              return <FAIcon key={i} name={a.icon} helpText={a.helpText} className={styles['boxAlertIcon' + (a.type || '')]} />
            })}
          </div> */}
      </div>
    )
  }

  renderDetails () {
    const { fields } = this.props

    const detailFields = _.filter(fields, (f) => { return _.isNil(f.type) })

    return (
      <div className={styles.cardFlexRow}>
        {_.map(detailFields, (f, i) => {
          let className = i === 0 ? styles.cardInfoColumnNoMargin : styles.cardInfoColumn
          return <div className={className}>
            <div className={styles.cardInfoColumnTitle}>{f.text}</div>
            <div className={styles.cardInfoColumnText}>{f.value}</div>
          </div>
        })}
      </div>
    )
  }

  render () {
    const { key, children, actions, onClick, sendToURL, addLayoutBreadCrumbKey, showGray, rowSpan, colSpan, noCursor } = this.props
    const cardStyle = {}

    if (rowSpan > 1) {
      cardStyle.gridRowEnd = `span ${rowSpan}`
    }

    if (colSpan === 0) {
      cardStyle.gridColumnStart = 1
      cardStyle.gridColumnEnd = -1
    } else if (colSpan > 1) {
      cardStyle.gridColumnEnd = `span ${colSpan}`
    }
    if (noCursor) {
      cardStyle.cursor = 'default'
    }

    let onClickFunction = null

    if (_.isFunction(onClick)) {
      onClickFunction = onClick
    } else if (_.isString(onClick)) {
      onClickFunction = () => {
        sendToURL(onClick)
      }
    } else if (_.isPlainObject(onClick)) {
      onClickFunction = () => {
        if (_.isArray(onClick.breadCrumbKey)) {
          _.each(onClick.breadCrumbKey, (bk) => {
            addLayoutBreadCrumbKey(bk.key, bk.value, bk.disabled)
          })
        } else {
          addLayoutBreadCrumbKey(onClick.breadCrumbKey.key, onClick.breadCrumbKey.value, onClick.breadCrumbKey.disabled)
        }
        sendToURL(onClick.url)
      }
    }

    let wrapperStyle = {}
    if (_.isNil(actions) === false) {
      if (actions.length > 0) {
        wrapperStyle.paddingRight = '70px'
      }
    }
    if (_.isFunction(onClick)) {
      wrapperStyle.cursor = 'pointer'
    }
    return (
      <div key={key} style={{ ...wrapperStyle, ...cardStyle }} className={`${styles.cardWrapper} ${showGray ? styles.disabled : ''}`} onClick={onClickFunction} >
        {this.renderSummary()}
        {this.renderDetails()}
        {this.renderActions()}
        {children}
      </div>
    )
  }
}

export const DataRow = compose(
  ReduxWrapper([sh.SessionAccount, sh.SessionToken], [ ah.addLayoutBreadCrumbKey, ah.sendToURL ])
)(DataRowPlain)

export default DataRow
